<template>
  <div class="uyh-next-steps" id="next-steps">
    <div class="success-image-wrapper">
      <img src="@/assets/images/share_success.jpg">
    </div>

    <div class="success-image-links">
      <p class="header">{{ $t('next_steps.inspired') }}</p>
      <div class="link-wrapper">
        <p><router-link @click.native='navClick' :to="'/pick-a-mantra'">{{ $t('next_steps.send_another') }}</router-link></p>
        <p><a href="" @click.prevent='clickLink("shop")'>{{ $t('next_steps.shopping_break') }}</a></p>
        <p><a href="" @click.prevent='clickLink("events")'>{{ $t('next_steps.store_events') }}</a></p>
      </div>
    </div>

    <div class="uyh-interstitial-background"  v-if="link != ''" @click="link = ''"></div>
    <div class="uyh-interstitial" v-if="link != ''">
      <img src="../assets/icons/Close_Icon.svg" class="close-links" @click="link = ''"/>
      <p tabindex=-1 class="title" :title="$t('interstitial.choose_location')">{{ $t('interstitial.choose_location') }}</p>
      <div class="link-wrapper" v-if="link == 'shop'">
        <div class="list-wrapper left">
          <p v-for="(link, country) in shoppingLinks.left" :key='country' class="list-item left-list">
            <a :href='link' @click='navClick' target="_blank">
              {{ country.split('_').join(' ').toUpperCase() }}
              <img v-if="link == 'https://www.facebook.com/pg/katespadeny/locations/'" src="../assets/icons/FB_pink.png" />
            </a>
          </p>
        </div>
        <div class="list-wrapper right">
          <p v-for="(link, country) in shoppingLinks.right" :key='country' class="list-item right-list">
            <a :href='link' @click='navClick' target="_blank">
              {{ country.split('_').join(' ').toUpperCase() }}
              <img v-if="link == 'https://www.facebook.com/pg/katespadeny/locations/'" src="../assets/icons/FB_pink.png" />
            </a>
          </p>
        </div>
      </div>

      <div class="link-wrapper" v-if="link == 'events'">
        <div class="list-wrapper left">
          <p v-for="(link, country) in storeEvents.left" :key='country' class="list-item left-list">
            <a :href='link' @click='navClick' target="_blank">
              {{ country.split('_').join(' ').toUpperCase() }}
              <img v-if="link == 'https://www.facebook.com/pg/katespadeny/locations/'" src="../assets/icons/FB_pink.png" />
            </a>
          </p>
        </div>
        <div class="list-wrapper right">
          <p v-for="(link, country) in storeEvents.right" :key='country' class="list-item right-list">
            <a :href='link' @click='navClick' target="_blank">
              {{ country.split('_').join(' ').toUpperCase() }}
              <img v-if="link == 'https://www.facebook.com/pg/katespadeny/locations/'" src="../assets/icons/FB_pink.png" />
            </a>
          </p>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import getCookie from '@/assets/javascripts/get_cookie'

  export default {
    data: function() {
      return {
        link: ""
      }
    },
    beforeMount: function () {
      this.$store.dispatch('updateShare', false);
      this.$store.dispatch('updateMantrapage', false);
      this.$store.dispatch('updateStore', {
        primarybackground: '',
        secondarybackground: '',
        textareacolor: '',
        textcolor: '',
        textstyle: '',
        textareaborder: ''
      });
    },
    methods: {
      clickLink: function(linkType) {
        let link = getCookie(`${linkType[0]}link`)
        if (link) {
          let title = (linkType == 'shop') ? 'shopping_break' : 'store_events'
          title = this.$t(`next_steps.${title}`)
          this.pushDataLayer(link, title)
          window.location.href = link
        } else {
          this.link = linkType
        }
      },
      navClick: function(e) {
        this.pushDataLayer(e.target.href, e.target.innerText)
      },
      pushDataLayer: function(path, title) {
        window.dataLayer.push({
          'event': 'nav-click',
          'clickPath': path,
          'clickTitle': title,
          'locale': getCookie('lang')
        });
      }
    },
    computed: {
      shoppingLinks: function() {
        return this.$t('interstitial.shopping_break');
      },
      storeEvents: function() {
        return this.$t('interstitial.store_events');
      }
    }
  }
</script>


<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    .uyh-next-steps {
      align-items: stretch;
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      position: relative;
      .success-image-wrapper {
        align-items: center;
        background-color: #223628;
        display: flex;
        flex: 0 0 70%;
        height: 100%;
        img {
          margin: 0 auto;
          width: 47%;
        }
      }
      .success-image-links {
        background-color: #FCEFF3;
        display: flex;
        flex: 0 0 30%;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
        p {
          flex: 0 1 auto;
          font-size: 20px;
          margin-bottom: 40px;
        }

        .header,
        .link-wrapper {
          flex: 0 1 auto;
        }
        .header {
          font-size: 28px;
          width: 100%;
        }
      }
    }

    @media screen and (max-width: 1023px) {
      .uyh-next-steps {
        flex-direction: column;
        flex-wrap: nowrap;
        .success-image-links {
          align-items: center;
          flex: 1 0 auto;
          flex-direction: row;
          margin-top: 0;
          padding: 31px 0 57px;
          width: 100%;
          .header {
            margin: 0;
          }
          .header,
          .link-wrapper {
            flex: 0 1 50%;
            width: 50%;
            p {
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
        .success-image-wrapper {
          flex: 1 0 auto;
          height: auto;
          order: 2;
          padding: 0;
          width: 100%;
          img {
            max-height: 100%;
            margin: calc(30.25% / 2) auto;
            width: 60.5%
          }
        }
      }
    }

    @media screen and (max-width: 767px) {
      .uyh-next-steps {
        .success-image-links,
        .success-image-wrapper {
          height: auto;
        }

        .success-image-links {
          align-content: center;
          padding: 20px 0;
          .header {
            font-size: 20px;
          }
          .header,
          .link-wrapper {
            flex: 0 1 100%;
            width: 100%;
          }

          p {
            margin-bottom: 0;
            margin-top: 32px;
          }
        }
        .success-image-wrapper {
          width: 100%;
          img {
            margin: calc(60.5% / 2) auto;
          }
        }
      }
    }

    .uyh-interstitial-background {
      background-color: tranparent;
      height: 100%;
      position: absolute;
      width: 100%;
    }

    .uyh-interstitial {
      background-color: #fc7ca0;
      display: flex;
      flex-wrap: wrap;
      left: 50%;
      max-width: 100%;
      padding: 68px 96px;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: 750px;

      .close-links {
        cursor: pointer;
        position: absolute;
        right: 23px;
        top: 23px;
      }

      .title {
        flex: 0 0 100%;
        font-size: 28px;
        margin: 0;
      }
      .link-wrapper {
        display: flex;
        flex: 0 0 100%;
        justify-content: space-between;
        margin: 0 auto;
        max-width: 400px;
        padding-top: 29px;
      }

      .list-wrapper {
        flex: 0 1 37%;
        .list-item {
          padding-top: 21px;
          margin: 0;
          text-align: left;
          a {
            display: inline;
            padding-right: 15px;
            position: relative;
            &:after {
              display: none;
            }
            &:hover {
              color: #22372b;
            }
            svg {
              display: inline-block;
              height: 12px;
              position: relative;
              width: 12px;
            }
          }
        }
      }
    }
    @media screen and (max-width: 1023px) {
      .uyh-interstitial {
        left: 0;
        height: 100%;
        padding: 68px 30px;
        top: 0;
        transform: none;
        width: 100%;
        .title {
          font-size: 22px;
        }
        .list-wrapper {
          flex: 0 0 48%;
        }
      }
    }
  }
</style>
